import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; 
import { useNavigate } from 'react-router-dom'; 
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    Button,
    Divider,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    styled,
    createTheme,
    ThemeProvider,
    Box,
    CardMedia,
} from '@mui/material';
import moment from 'moment'; 
import Footer from '../navbar/Footer';

const bulletinsPrixData = [
     {
        title: 'Bulletin mensuel des prix pour Février 2026',
        link: "/documents/Bulletins/BULLETIN_Feb2026.pdf",
        date: new Date('2026-02-15'),
        datePublication: new Date('2026-03-17'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle de février 2026 s'élève à +29,0% contre +31,6% en janvier 2026.",
    },
     {
        title: 'Bulletin mensuel des prix pour Janvier 2026',
        link: "/documents/Bulletins/BULLETIN_Jan2026.pdf",
        date: new Date('2026-01-15'),
        datePublication: new Date('2026-02-17'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle de janvier 2026 s'élève à +31,6% contre +34,0% en décembre 2025.",
    },
       {
        title: 'Bulletin mensuel des prix pour Décembre 2025',
        link: "/documents/Bulletins/BULLETIN_Dec_25.pdf",
        date: new Date('2025-12-15'),
        datePublication: new Date('2026-01-17'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle de l'année 2025 s'élève à +34,0% contre +20,2% de l'année 2024.",
    },
       {
        title: 'Bulletin mensuel des prix pour Novembre 2025',
        link: "/documents/Bulletins/BUL_5pov_Nov_25_merged.pdf",
        date: new Date('2025-11-15'),
        datePublication: new Date('2025-12-17'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois de novembre 2025 s'élève à +36,1% contre +36,8% le mois d'octobre 2025.",
    },
    
      {
        title: 'Bulletin mensuel des prix pour octobre 2025',
        link: "/documents/Bulletins/10_BUL_5pov_OCT_25_merged.pdf",
        date: new Date('2025-10-15'),
        datePublication: new Date('2025-12-17'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois d'octobre 2025 s'élève à +36,8% contre +36,9% le mois de septembre 2025.",
    },
     {
        title: 'Bulletin mensuel des prix pour Septembre 2025',
        link: "/documents/Bulletins/1BUL_5pov_Sept25_merged.pdf",
        date: new Date('2025-09-15'),
        datePublication: new Date('2025-12-17'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois de septembre 2025 s'élève à +36,9% contre +36,6% le mois d'août 2025.  ",
    },
     {
        title: 'Bulletin mensuel des prix pour Août 2025',
        link: "/documents/Bulletins/8_BUL_Prov_Aout_25_merged.pdf",
        date: new Date('2025-08-15'),
        datePublication: new Date('2025-11-18'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois d’août  2025 s'élève à +36,6% contre +35,4% le mois de juillet 2025. ",
    },
     {
        title: 'Bulletin mensuel des prix pour Juillet 2025',
        link: "/documents/Bulletins/7_BULL_5Prov_Juil_merged.pdf",
        date: new Date('2025-07-15'),
        datePublication: new Date('2025-11-18'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois de juillet 2025 s'élève à +35,4% contre +33,8% le mois de juin 2025. ",
    },
     {
        title: 'Bulletin mensuel des prix pour Juin 2025',
        link: "/documents/Bulletins/6_BUL_ june2025_merged.pdf",
        date: new Date('2025-06-15'),
        datePublication: new Date('2025-11-18'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois de juin 2025 s’élève à +33,8% contre +31,6% le mois de mai 2025. ",
    },
     {
        title: 'Bulletin mensuel des prix pour Mai 2025',
        link: "/documents/Bulletins/5_BUL_May2025_merged.pdf",
        date: new Date('2025-05-15'),
        datePublication: new Date('2025-11-18'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois de mai 2025 s’élève à +31,6% contre +29,0% le mois d’avril 2025",
    },
     {
        title: 'Bulletin mensuel des prix pour Avril 2025',
        link: "/documents/Bulletins/4_BUL_Avril2025_merged.pdf",
        date: new Date('2025-04-15'),
        datePublication: new Date('2025-11-18'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation en moyenne annuelle du mois d'avril 2025 s'élève à +29,0% contre +26,1% le mois de mars 2025.",
    },
      {
        title: 'Bulletin mensuel des prix pour mars 2025',
        link: "/documents/Bulletins/BUL_March2025.pdf",
        date: new Date('2025-04-15'),
        datePublication: new Date('2025-03-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L’inflation en moyenne annuelle du mois de mars 2025 s’élève à +26,1% contre +23,8% le mois de février 2025.",
    },
      {
        title: 'Bulletin mensuel des prix pour février 2025',
        link: "/documents/Bulletins/BUL_FEB2025.pdf",
        date: new Date('2025-03-15'),
        datePublication: new Date('2025-02-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L’inflation en moyenne annuelle du mois de février 2025 s’élève à +23,8% contre +22,0% le mois de janvier 2025.",
    },
    {
        title: 'Bulletin mensuel des prix pour janvier 2025',
        link: "/documents/Bulletins/BUL01-2025.pdf",
        date: new Date('2025-02-15'),
        datePublication: new Date('2025-01-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L’inflation en moyenne annuelle du mois de janvier 2025 s’élève à +22,0% contre +20,2% le mois de décembre 2024.",
    },
    {
        title: 'Bulletin mensuel des prix pour décembre 2024',
        link: '/documents/Bulletins/BUL-12-2024.pdf',
        date: new Date('2025-01-15'),
        datePublication: new Date('2024-12-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: " L’inflation en moyenne annuelle de l’année 2024 s’élève à +20,2% contre +27,1% en 2023. ",
    },
    {
        title: 'Bulletin mensuel des prix pour novembre 2024',
        link: '/documents/Bulletins/BUL-11-2024.pdf',
        date: new Date('2024-12-15'),
        datePublication: new Date('2024-11-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L’inflation en moyenne annuelle du mois de novembre 2024 s’élève à +18,8% contre +18,0% le mois d’octobre 2024.",
    },
    {
        title: 'Bulletin mensuel des prix pour octobre 2024',
        link: '/documents/Bulletins/BUL-10-2024.pdf',
        date: new Date('2024-11-15'),
        datePublication: new Date('2024-10-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation annuelle moyenne de +18,0 %, contre +17,9 % en septembre 2024.",
    },
    {
        title: 'Bulletin mensuel des prix pour septembre 2024',
        link: '/documents/Bulletins/BUL-09-2024.pdf',
        date: new Date('2025-10-15'),
        datePublication: new Date('2024-09-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation annuelle moyenne de +17,9 %, contre +18,1 % en août 2024.",
    },
    {
        title: 'Bulletin mensuel des prix pour août 2024',
        link: '/documents/Bulletins/BUL-08-2024.pdf',
        date: new Date('2024-09-15'),
        datePublication: new Date('2024-08-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation annuelle moyenne de +18,1 %, contre +18,9 % en juillet 2024.",
    },
    {
        title: 'Bulletin mensuel des prix pour juillet 2024',
        link: '/documents/Bulletins/BUL-07-2024.pdf',
        date: new Date('2024-08-15'),
        datePublication: new Date('2024-07-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'inflation annuelle moyenne de +18,9 %, contre +19,4 % en juin 2024.",
    },
    {
        title: 'Bulletin mensuel des prix pour juin 2024',
        link: '/documents/Bulletins/BUL-06-2024.pdf',
        date: new Date('2024-07-05'),
        datePublication: new Date('2024-06-30'), 
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation en moyenne annuelle du mois de juin 2024 qui s’élève à +19,4% contre +20,3% le mois de mai 2024.',
    },
    {
        title: 'Bulletin mensuel des prix pour mai 2024',
        link: '/documents/Bulletins/BUL-05-2024.pdf',
        date: new Date('2024-06-05'),
        datePublication: new Date('2024-05-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation en moyenne annuelle du mois de mai 2024 qui s’élève à +20,3% contre +21,7% le mois d’avril 2024.',
    },
    {
        title: 'Bulletin mensuel des prix pour avril 2024',
        link: '/documents/Bulletins/BUL-04-2024-1.pdf',
        date: new Date('2024-05-05'),
        datePublication: new Date('2024-04-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle du mois d’avril 2024 qui s’élève à +21,7% contre +23,5% le mois de mars 2024.',
    },
    {
        title: 'Bulletin mensuel des prix pour mars 2024',
        link: '/documents/Bulletins/BUL-03-2024.pdf',
        date: new Date('2024-04-05'),
        datePublication: new Date('2024-03-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de mars 2024 qui s’élève à +23,5% contre +25,1% le mois de février 2024.',
    },
    {
        title: 'Bulletin mensuel des prix pour février 2024',
        link: '/documents/Bulletins/BUL-02-2024.pdf',
        date: new Date('2024-03-05'),
        datePublication: new Date('2024-02-29'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de février 2024 qui s’élève à +25,1% contre +26,1% le mois de janvier 2024.',
    },
    {
        title: 'Bulletin mensuel des prix pour janvier 2024',
        link: '/documents/Bulletins/BUL-01-2024.pdf',
        date: new Date('2024-02-05'),
        datePublication: new Date('2024-01-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de janvier 2024 qui s’élève à +26,1% contre +27,1% l’année 2023.',
    },
    {
        title: 'Bulletin mensuel des prix pour décembre 2023',
        link: '/documents/Bulletins/BUL-12-2023.pdf',
        date: new Date('2024-01-05'),
        datePublication: new Date('2023-12-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de l’année 2023 qui s’élève à +27,1% contre 18,9% en 2022.',
    },
    {
        title: 'Bulletin mensuel des prix pour novembre 2023',
        link: '/documents/Bulletins/BUL-11-2023.pdf',
        date: new Date('2023-12-05'),
        datePublication: new Date('2023-11-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de novembre 2023 qui s’élève à +27,7% contre +28,3% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour octobre 2023',
        link: '/documents/Bulletins/BUL-10-2023.pdf',
        date: new Date('2023-11-05'),
        datePublication: new Date('2023-10-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle d’octobre 2023 qui s’élève à +28,3% contre +28,0% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour septembre 2023',
        link: '/documents/Bulletins/BUL-09-2023.pdf',
        date: new Date('2023-10-05'),
        datePublication: new Date('2023-09-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de septembre 2023 qui s’élève à +28,0% contre +27,5% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour août 2023',
        link: '/documents/Bulletins/BUL-08-2023.pdf',
        date: new Date('2023-09-05'),
        datePublication: new Date('2023-08-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle d’août 2023 qui s’élève à +27,5% contre +26,8% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour juillet 2023',
        link: '/documents/Bulletins/BUL-07-2023.pdf',
        date: new Date('2023-08-05'),
        datePublication: new Date('2023-07-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de juillet 2023 qui s’élève à +26,8% contre +26,3% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour juin 2023',
        link: '/documents/Bulletins/Bulletin-mensuel-juin-fn-2023.pdf',
        date: new Date('2023-07-05'),
        datePublication: new Date('2023-06-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de juin 2023 qui s’élève à +26,3% contre +25,5% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour mai 2023',
        link: '/documents/Bulletins/Bulletin-mensuel-mai-2023.pdf',
        date: new Date('2023-06-05'),
        datePublication: new Date('2023-05-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de mai 2023 qui s’élève à +25,5% contre +24,6% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour avril 2023',
        link: '/documents/Bulletins/Bulletin-mensuel-avril-2023fn.pdf',
        date: new Date('2023-05-05'),
        datePublication: new Date('2023-04-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle d’avril 2023 qui s’élève à +24,6% contre +23,2% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour mars 2023',
        link: '/documents/Bulletins/Bulletin-mensuel-mars-fn-2023.pdf',
        date: new Date('2023-04-05'),
        datePublication: new Date('2023-03-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de mars 2023 qui  s’élève à +23,2% contre +21,5% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour février 2023',
        link: '/documents/Bulletins/Bulletin-mensuel-fevrier-fn-2023-1.pdf',
        date: new Date('2023-03-05'),
        datePublication: new Date('2023-02-28'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de février 2023 qui s’élève à +21,5% contre +20,3% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour janvier 2023',
        link: '/documents/Bulletins/Bulletin-mensuel-janvier-fn-2023.pdf',
        date: new Date('2023-02-05'),
        datePublication: new Date('2023-01-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation moyenne annuelle de janvier 2023 qui s’élève à +20,3% contre +18,9% du mois précédent.',
    },
    {
        title: 'PRIX A LA CONSOMMATION DES MENAGES DE BUJUMBURA MAIRIE de 2020-2022 MOIS: D\'AVRIL 2022',
        link: '/documents/Bulletins/bulletins-mensuels-serie-de-2020-2022.pdf',
        date: new Date('2022-04-05'),
        datePublication: new Date('2022-04-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: "L'analyse des prix à la consommation des ménages de Bujumbura Mairie pour avril 2022, avec un focus sur les tendances de fin d\'année et les évolutions du marché.",
    },
  
    {
        title: 'Bulletin mensuel des prix pour décembre 2022',
        link: '/documents/Bulletins/BUL-DECEMBRE-2022.pdf',
        date: new Date('2023-01-05'),
        datePublication: new Date('2022-12-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'L’inflation pour janvier 2023, avec une hausse annuelle de +20,3% contre +18,9% du mois précédent.',
    },
    {
        title: 'Bulletin mensuel des prix pour novembre 2022',
        link: '/documents/Bulletins/BULL-NOV22.pdf',
        date: new Date('2022-12-05'),
        datePublication: new Date('2022-11-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Un aperçu détaillé des prix en fin d\'année, avec des données clés et des analyses sectorielles approfondies.',
    },
    {
        title: 'Bulletin mensuel des prix pour octobre 2022',
        link: '/documents/Bulletins/BULL-OCT22.pdf',
        date: new Date('2022-11-05'),
        datePublication: new Date('2022-10-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour octobre 2022, avec un focus sur les fluctuations saisonnières, les impacts des événements économiques et leurs effets sur les consommateurs.',
    },
    {
        title: 'Bulletin mensuel des prix pour septembre 2022',
        link: '/documents/Bulletins/BUL-Septembre-22.pdf',
        date: new Date('2022-10-05'),
        datePublication: new Date('2022-09-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de septembre 2022 détaille les tendances des prix sur le marché, incluant une analyse approfondie des produits de base et des indicateurs économiques.',
    },
    {
        title: 'Bulletin mensuel des prix pour août 2022',
        link: '/documents/Bulletins/bull-juill-2022-pdf.pdf',
        date: new Date('2022-09-05'),
        datePublication: new Date('2022-08-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour août 2022, avec un focus sur les fluctuations saisonnières, les défis économiques et leur impact sur les consommateurs et les entreprises.',
    },
    {
        title: 'Bulletin mensuel des prix pour juillet 2022',
        link: '/documents/Bulletins/bull-juill-2022-pdf.pdf',
        date: new Date('2022-08-05'),
        datePublication: new Date('2022-07-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de juillet 2022 présente une vue d\'ensemble des prix, incluant les secteurs clés, les variations notables et les facteurs influençant le marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour juin 2022',
        link: '/documents/Bulletins/juin22.pdf',
        date: new Date('2022-07-05'),
        datePublication: new Date('2022-06-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Ce rapport de juin 2022 examine les tendances de prix et offre des insights sur les stratégies de marché, en tenant compte des événements économiques et des changements réglementaires.',
    },
    {
        title: 'Bulletin mensuel des prix pour mai 2022',
        link: '/documents/Bulletins/mai22.pdf',
        date: new Date('2022-06-05'),
        datePublication: new Date('2022-05-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de mai 2022 offre une analyse complète des prix, incluant des comparaisons annuelles, des prévisions et des recommandations pour les acteurs du marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour avril 2022',
        link: '/documents/Bulletins/avril-22.pdf',
        date: new Date('2022-05-05'),
        datePublication: new Date('2022-04-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin d\'avril 2022 propose un aperçu détaillé des prix en début d\'année, avec des données clés, des analyses sectorielles et des prévisions pour les mois à venir.',
    },
    {
        title: 'Bulletin mensuel des prix pour mars 2022',
        link: '/documents/Bulletins/MARS-22-EX.pdf',
        date: new Date('2022-04-05'),
        datePublication: new Date('2022-03-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour mars 2022, avec un focus sur les tendances de fin d\'année et les impacts des événements économiques sur le marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour février 2022',
        link: '/documents/Bulletins/fevrier-ex.pdf',
        date: new Date('2022-03-05'),
        datePublication: new Date('2022-02-28'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Ce rapport de février 2022 examine les tendances de prix et offre des insights sur les stratégies de marché, en tenant compte des facteurs géopolitiques et des évolutions économiques.',
    },
    {
        title: 'Bulletin mensuel des prix pour janvier 2022',
        link: '/documents/Bulletins/BUL-janvier-2022-Ex.pdf',
        date: new Date('2022-02-05'),
        datePublication: new Date('2022-01-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de janvier 2022 offre une analyse complète des prix, incluant des comparaisons annuelles, des prévisions et des recommandations pour les acteurs du marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour décembre 2021',
        link: '/documents/Bulletins/dec-21.pdf',
        date: new Date('2022-01-05'),
        datePublication: new Date('2021-12-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de décembre 2021 propose un aperçu détaillé des prix en début d\'année, avec des données clés, des analyses sectorielles et des prévisions pour les mois à venir.',
    },
    {
        title: 'Bulletin mensuel des prix pour novembre 2021',
        link: '/documents/Bulletins/novembre21.pdf',
        date: new Date('2021-12-05'),
        datePublication: new Date('2021-11-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour novembre 2021, avec un focus sur les tendances de fin d\'année et les impacts des événements économiques sur le marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour octobre 2021',
        link: '/documents/Bulletins/OCTOBRE21.pdf',
        date: new Date('2021-11-05'),
        datePublication: new Date('2021-10-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Ce rapport d\'octobre 2021 examine les tendances de prix et offre des insights sur les stratégies de marché, en tenant compte des facteurs géopolitiques et des évolutions économiques.',
    },
    {
        title: 'Bulletin mensuel des prix pour septembre 2021',
        link: '/documents/Bulletins/SEPT-21.pdf',
        date: new Date('2021-10-05'),
        datePublication: new Date('2021-09-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de septembre 2021 offre une analyse complète des prix, incluant des comparaisons annuelles, des prévisions et des recommandations pour les acteurs du marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour août 2021',
        link: '/documents/Bulletins/AOUT-21.pdf',
        date: new Date('2021-09-05'),
        datePublication: new Date('2021-08-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin d\'août 2021 propose un aperçu détaillé des prix en fin d\'année, avec des données clés et des analyses sectorielles approfondies.',
    },
    {
        title: 'Bulletin mensuel des prix pour juillet 2021',
        link: '/documents/Bulletins/bull-juillet21.pdf',
        date: new Date('2021-08-05'),
        datePublication: new Date('2021-07-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour juillet 2021, avec un focus sur les fluctuations saisonnières, les défis économiques et leur impact sur les consommateurs et les entreprises.',
    },
    {
        title: 'Bulletin mensuel des prix pour juin 2021',
        link: '/documents/Bulletins/BULL-JUIN21.pdf',
        date: new Date('2021-07-05'),
        datePublication: new Date('2021-06-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de juin 2021 détaille les tendances des prix sur le marché, incluant une analyse approfondie des produits de base et des indicateurs économiques.',
    },
    {
        title: 'Bulletin mensuel des prix pour mai 2021',
        link: '/documents/Bulletins/MAI21.pdf',
        date: new Date('2021-06-05'),
        datePublication: new Date('2021-05-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour mai 2021, avec un focus sur les fluctuations saisonnières et leur impact sur les consommateurs et les entreprises.',
    },
    {
        title: 'Bulletin mensuel des prix pour avril 2021',
        link: '/documents/Bulletins/MARS-21.pdf',
        date: new Date('2021-05-05'),
        datePublication: new Date('2021-04-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin d\'avril 2021 présente une vue d\'ensemble des prix, incluant les secteurs clés, les variations notables et les facteurs influençant le marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour mars 2021',
        link: '/documents/Bulletins/MARS-21.pdf',
        date: new Date('2021-04-05'),
        datePublication: new Date('2021-03-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Ce rapport de mars 2021 examine les tendances de prix et offre des insights sur les stratégies de marché, en tenant compte des événements économiques et des changements réglementaires.',
    },
    {
        title: 'Bulletin mensuel des prix pour février 2021',
        link: '/documents/Bulletins/fevrier21.pdf',
        date: new Date('2021-03-05'),
        datePublication: new Date('2021-02-28'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de février 2021 offre une analyse complète des prix, incluant des comparaisons annuelles, des prévisions et des recommandations pour les acteurs du marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour janvier 2021',
        link: '/documents/Bulletins/janv21.pdf',
        date: new Date('2021-02-05'),
        datePublication: new Date('2021-01-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de janvier 2021 propose un aperçu détaillé des prix en début d\'année, avec des données clés, des analyses sectorielles et des prévisions pour les mois à venir.',
    },
    {
        title: 'Bulletin mensuel des prix pour décembre 2020',
        link: '/documents/Bulletins/BULLETIN-DEC20.pdf',
        date: new Date('2021-01-05'),
        datePublication: new Date('2020-12-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour décembre 2020, avec un focus sur les tendances de fin d\'année et les impacts des événements économiques sur le marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour novembre 2020',
        link: '/documents/Bulletins/',
        date: new Date('2020-12-05'),
        datePublication: new Date('2020-11-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de novembre 2020 propose un aperçu détaillé des prix en début d\'année, avec des données clés, des analyses sectorielles et des prévisions pour les mois à venir.',
    },
    {
        title: 'Bulletin mensuel des prix pour octobre 2020',
        link: '/documents/Bulletins/Bulletin-octob20.pdf',
        date: new Date('2020-11-05'),
        datePublication: new Date('2020-10-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin d\'octobre 2020 offre une analyse complète des prix, incluant des comparaisons annuelles, des prévisions et des recommandations pour les acteurs du marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour août 2020',
        link: '/documents/Bulletins/BLM202008.pdf',
        date: new Date('2020-09-05'),
        datePublication: new Date('2020-08-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin d\'août 2020 offre une analyse complète des prix, incluant des comparaisons annuelles, des prévisions et des recommandations pour les acteurs du marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour juillet 2020',
        link: '/documents/Bulletins/BLM202007.pdf',
        date: new Date('2020-08-05'),
        datePublication: new Date('2020-07-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de juillet 2020 propose un aperçu détaillé des prix en fin d\'année, avec des données clés et des analyses sectorielles approfondies.',
    },
    {
        title: 'Bulletin mensuel des prix pour juin 2020',
        link: '/documents/Bulletins/BLM202006.pdf',
        date: new Date('2020-07-05'),
        datePublication: new Date('2020-06-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de juin 2020 détaille les tendances des prix sur le marché, incluant une analyse approfondie des produits de base et des indicateurs économiques.',
    },
    {
        title: 'Bulletin mensuel des prix pour mai 2020',
        link: '/documents/Bulletins/BLM202005.pdf',
        date: new Date('2020-06-05'),
        datePublication: new Date('2020-05-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Analyse des prix pour mai 2020, avec un focus sur les fluctuations saisonnières, les impacts des événements économiques et leurs effets sur les consommateurs.',
    },
    {
        title: 'Bulletin mensuel des prix pour avril 2020',
        link: '/documents/Bulletins/BLM202004.pdf',
        date: new Date('2020-05-05'),
        datePublication: new Date('2020-04-30'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin d\'avril 2020 présente une vue d\'ensemble des prix, incluant les secteurs clés, les variations notables et les facteurs influençant le marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour mars 2020',
        link: '/documents/Bulletins/BLM202003.pdf',
        date: new Date('2020-04-05'),
        datePublication: new Date('2020-03-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Ce rapport de mars 2020 examine les tendances de prix et offre des insights sur les stratégies de marché, en tenant compte des événements économiques et des changements réglementaires.',
    },
    {
        title: 'Bulletin mensuel des prix pour février 2020',
        link: '/documents/Bulletins/BLM202002.pdf',
        date: new Date('2020-03-05'),
        datePublication: new Date('2020-02-29'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de février 2020 offre une analyse complète des prix, incluant des comparaisons annuelles, des prévisions et des recommandations pour les acteurs du marché.',
    },
    {
        title: 'Bulletin mensuel des prix pour janvier 2020',
        link: '/documents/Bulletins/BLM202001.pdf',
        date: new Date('2020-02-05'),
        datePublication: new Date('2020-01-31'),
        image: 'assets/Bulletins/bulletin-prix.png',
        description: 'Le bulletin de janvier 2020 propose un aperçu détaillé des prix en début d\'année, avec des données clés, des analyses sectorielles et des prévisions pour les mois à venir.',
    },
];
function BulletinsPrix() {
    const navigate = useNavigate();
    const [visibleCount, setVisibleCount] = useState(4);
    const [selectedYear, setSelectedYear] = useState('Tous');
    const [filteredBulletins, setFilteredBulletins] = useState(bulletinsPrixData);

    const handleShowMore = () => {
        setVisibleCount((prevCount) => prevCount + 2);
    };

    const handleYearChange = (event) => {
        const year = event.target.value;
        setSelectedYear(year);

        if (year === 'Tous') {
            setFilteredBulletins(bulletinsPrixData.sort((a, b) => b.datePublication - a.datePublication));
            setVisibleCount(4);
        } else {
            const filtered = bulletinsPrixData.filter((bulletin) => {
                const bulletinYear = new Date(bulletin.datePublication).getFullYear();
                return bulletinYear === parseInt(year);
            });
            setFilteredBulletins(filtered.sort((a, b) => b.datePublication - a.datePublication));
            setVisibleCount(2);
        }
    };

    const StyledSelect = styled(Select)(({ theme }) => ({
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.main,
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.light,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.primary.dark,
        },
    }));

    const theme = createTheme({
        palette: {
            primary: {
                main: '#388E3C',
            },
            secondary: {
                main: '#f50057',
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 'bold',
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        transition: 'transform 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'scale(1.03)',
                            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
                        },
                    },
                },
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <div style={{ backgroundColor: '#f0f4f8', paddingBottom: '20px' }}>
                <NavigationBar />
                <Container maxWidth="lg" style={{ paddingTop: '60px' }}>
                    <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
                        Les Bulletins Mensuels des Prix
                    </Typography>
                    <Divider style={{ margin: '20px 0' }} />
                    <Typography variant="body1" align="left" gutterBottom>
                        Cette section vous offre un accès direct aux analyses mensuelles des prix. Découvrez des rapports complets qui présentent les indicateurs clés et les dernières tendances des prix.
                    </Typography>

                    {/* Filtre par année */}
                    <FormControl fullWidth margin="normal" style={{ marginLeft: '0px', width: '300px' }}>
                        <InputLabel id="year-select-label"> Sélectionnez une année de publication</InputLabel>
                        <StyledSelect
                            labelId="year-select-label"
                            id="year-select"
                            value={selectedYear}
                            onChange={handleYearChange}
                            label="Sélectionnez une année de publication"
                            variant="outlined"
                        >
                            <MenuItem value="Tous">Tous les bulletins</MenuItem>
                            {[
                                ...new Set(
                                    bulletinsPrixData.map((bulletin) => new Date(bulletin.datePublication).getFullYear())
                                )
                            ]
                                .sort((a, b) => b - a) 
                                .map((year) => (
                                    <MenuItem key={year} value={year.toString()}>
                                        {year}
                                    </MenuItem>
                                ))}
                        </StyledSelect>
                    </FormControl>

                    <Grid container spacing={1} style={{ marginTop: '10px' }}>
                        {filteredBulletins.slice(0, visibleCount).map((bulletin, index) => (
                            <Grid item xs={12} sm={6} md={12} key={index}>
                                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Box sx={{ display: 'flex' }}>
                                        <CardMedia
                                            component="img"
                                            sx={{ width: 71, height: 90, m: 2, cursor: 'pointer' }}
                                            image={bulletin.image}
                                            alt={bulletin.title}
                                            onClick={() => window.open(bulletin.link, '_blank')} 
                                        />
                                        <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                                                <a
                                                    href={bulletin.link}
                                                    style={{ textDecoration: 'none', color: 'inherit' }}
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                >
                                                    {<DownloadIcon />}{bulletin.title}
                                                </a>
                                            </Typography>
                                            <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                                                {bulletin.description}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                Publié le {moment(bulletin.datePublication).format('DD/MM/YYYY')}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>

                    {/* Bouton "Plus de bulletins" */}
                    {visibleCount < filteredBulletins.length && (
                        <Button
                            onClick={handleShowMore}
                            style={{
                                marginTop: '20px',
                                backgroundColor: theme.palette.primary.main,
                                color: 'white',
                            }}
                        >
                            Plus de Bulletins
                        </Button>
                    )}
                    <Typography variant="caption" color="textSecondary">
                        <br />
                        <br />                    
                    </Typography>
                    <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
                        <strong>Notes :</strong> Les Bulletins Mensuels des Prix, qui fournissent des analyses essentielles sur l'évolution des prix, sont publiés chaque mois le <strong>15</strong>, soit 15 jours après la fin du mois précédent.
                        Voici les dates de publication prévues pour les mois à venir :
                        <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
                            <li><strong>15 janvier</strong> - Publication du bulletin pour le mois de décembre</li>
                            <li><strong>15 février</strong> - Publication du bulletin pour le mois de janvier</li>
                            <li><strong>15 mars</strong> - Publication du bulletin pour le mois de février</li>
                            <li><strong>15 avril</strong> - Publication du bulletin pour le mois de mars</li>
                            <li><strong>15 mai</strong> - Publication du bulletin pour le mois d'avril</li>
                            <li><strong>15 juin</strong> - Publication du bulletin pour le mois de mai</li>
                            <li><strong>15 juillet</strong> - Publication du bulletin pour le mois de juin</li>
                            <li><strong>15 août</strong> - Publication du bulletin pour le mois de juillet</li>
                            <li><strong>15 septembre</strong> - Publication du bulletin pour le mois d'août</li>
                            <li><strong>15 octobre</strong> - Publication du bulletin pour le mois de septembre</li>
                            <li><strong>15 novembre</strong> - Publication du bulletin pour le mois d'octobre</li>
                            <li><strong>15 décembre</strong> - Publication du bulletin pour le mois de novembre</li>
                        </ul>
                    </Typography>
                    <Box display="flex" justifyContent="flex-start" alignItems="center">
                        <Button
                            onClick={() => navigate('/bulletin')}
                            style={{
                                marginTop: '5px',
                                backgroundColor: theme.palette.primary.main,
                                color: 'white',
                            }}
                        >
                            <ArrowBackIcon style={{ marginRight: '8px' }} />
                            Retour à la page des bulletins
                        </Button>
                    </Box>
                </Container>
                <Typography variant="caption" color="textSecondary">
                    <br />
                    <br />                    
                </Typography>
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default BulletinsPrix;